<template>
  <div class="about-this-banner">
    <asset-meta :resource="currentResource"></asset-meta>

    <a :href="url" target="_blank">
      <font-awesome-icon icon="window-restore" />

      <span>Open in new window</span>
    </a>
  </div>
</template>

<script>
import AssetMeta from './AssetMeta';
import { mapGetters } from 'vuex';
import { stateAwarePath } from '@/support';

export default {
  computed: {
    ...mapGetters(['currentResource']),

    url() {
      return stateAwarePath(this.currentResource);
    },
  },

  components: {
    AssetMeta,
  },
};
</script>

<style lang="scss" scoped>
.about-this-banner {
  border-radius: 0.3rem;
  padding: 0.5rem 1rem;

  display: flex;
  flex-flow: row nowrap;
  margin: 1rem 0;
  justify-content: space-between;

  background: #f8f8f8;
  border-radius: 0.3rem;

  @include dark {
    background-color: #111;
    color: #aaa;
  }

  :deep(.banner-meta) {
    flex-flow: row nowrap;
    align-items: center;
    font-size: 1.2rem;

    > div {
      opacity: 1;
    }

    > * {
      margin-right: 1rem;
    }

    > div {
      font-size: 1.1rem;
    }

    .name {
      white-space: nowrap;
    }

    .tag {
      background-color: #e5e5e5;

      @include dark {
        background-color: #444;
        color: #eee;
      }
    }
  }

  a {
    font-size: 1.2rem;
    margin-left: 0.5rem;
    color: #888;
    text-decoration: none;

    @include dark {
      color: #777;
    }

    &:hover {
      color: #444;
    }

    span {
      display: none;
    }
  }
}
</style>
